export default __webpack_public_path__ + "static/media/unable-to-accept-invite.18cba97e.png";